var _defs, _path, _path2, _path3, _g, _path4, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPhotoPaper = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 60 60",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_photo_paper_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.691 12.398h42.75v35.25H8.691Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_photo_paper_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.094 20.05h3.75v3.75h-3.75Zm0 0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-6-6h72v72H-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-6-6h72v72H-6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.457 22.645a.759.759 0 1 1 .001-1.514.759.759 0 0 1-.001 1.514Zm0 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_photo_paper_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.223 46.066h39.55V17.621H38.828a.77.77 0 0 1-.723-.527l-1.25-3.168H23.137l-1.266 3.21a.778.778 0 0 1-.707.485H10.223ZM50.53 47.59H9.465a.77.77 0 0 1-.77-.766v-29.96a.77.77 0 0 1 .77-.766h11.183l1.25-3.172a.771.771 0 0 1 .723-.528h14.754c.3.008.586.192.703.493l1.27 3.207H50.53c.422 0 .766.343.766.765v29.961a.767.767 0 0 1-.766.766Zm0 0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.996 22.48a9.356 9.356 0 0 1 9.367 9.367 9.352 9.352 0 0 1-2.738 6.618 9.347 9.347 0 0 1-6.629 2.75 9.345 9.345 0 0 1-6.625-2.75 9.355 9.355 0 0 1-2.742-6.617 9.36 9.36 0 0 1 2.742-6.625 9.338 9.338 0 0 1 6.625-2.743Zm5.55 3.817a7.83 7.83 0 0 0-5.55-2.3c-2.16 0-4.125.878-5.547 2.3a7.803 7.803 0 0 0-2.3 5.55c0 2.165.878 4.13 2.3 5.54a7.828 7.828 0 0 0 5.547 2.3 7.83 7.83 0 0 0 5.55-2.3 7.782 7.782 0 0 0 2.302-5.54 7.803 7.803 0 0 0-2.301-5.55Zm0 0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_photo_paper_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.844 21.926c0 .246-.047.484-.145.715-.094.23-.23.433-.406.609a1.832 1.832 0 0 1-.61.406 1.87 1.87 0 0 1-.714.145 1.889 1.889 0 0 1-1.735-1.16 1.885 1.885 0 0 1 0-1.434c.098-.23.23-.434.407-.61.175-.175.379-.312.609-.406a1.885 1.885 0 0 1 2.043.407c.176.175.312.379.406.609.098.23.145.469.145.719Zm0 0"
  }))));
};
export default SvgIconPhotoPaper;